import { Flex } from "@aircall/tractor";

import { ScoreBadge } from "@/blocks/ScoreBadge";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

const tones: { tone: ScoreBadge.Props["tone"]; content: string }[] = [
  { tone: "success", content: "95" },
  { tone: "success-alt", content: "78" },
  { tone: "warning", content: "52" },
  { tone: "destructive", content: "28" },
  { tone: "muted", content: "--" },
];

function Bordered() {
  return (
    <Flex gap="s" flexWrap="wrap" alignItems="center">
      {tones.map(({ tone, content }) => (
        <ScoreBadge key={tone} tone={tone}>
          {content}
        </ScoreBadge>
      ))}
    </Flex>
  );
}

function Borderless() {
  return (
    <Flex gap="s" flexWrap="wrap" alignItems="center">
      {tones.map(({ tone, content }) => (
        <ScoreBadge key={tone} tone={tone} borderless>
          {content}
        </ScoreBadge>
      ))}
    </Flex>
  );
}

function ToneScale() {
  return (
    <Flex gap="m" flexDirection="column">
      {tones.map(({ tone, content }) => (
        <Flex key={tone} gap="s" alignItems="center">
          <ScoreBadge tone={tone}>{content}</ScoreBadge>
          <span>{tone}</span>
        </Flex>
      ))}
    </Flex>
  );
}

export function PlaygroundScoreBadge() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Bordered</PlaygroundSubSectionTitle>
        <Bordered />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Borderless</PlaygroundSubSectionTitle>
        <Borderless />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Tone Scale</PlaygroundSubSectionTitle>
        <ToneScale />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
